<div id="dark" class="page-alignment">
  <div class="d-flex flex-xl-row flex-lg-row flex-md-column  flex-column custom-gap profile-card m-3">
    <div class="d-flex  align-items-center  justify-content-center custom-gap">
      <div
        class="d-flex flex-row justify-content-around align-items-center "
      >
        <button routerLink="/home" mat-icon-button class="text-muted">
          <mat-icon *ngIf="translate.currentLang == 'en'">arrow_back_ios</mat-icon>
          <mat-icon *ngIf="translate.currentLang == 'ar'">arrow_forward_ios</mat-icon>
        </button>
        <div *ngIf="company" matTooltipPosition="above" matTooltipClass="custom-tooltip"
          [matTooltip]="(translate.currentLang=='en')?company.ENG_NAME:company.ARB_NAME" style="font-size:18px"
          class="m-1">
          {{tempReuters}}
          <br>
          <small>
            <span class="d-flex">
              <i style="display:none;" *ngIf="isFav(company.SYMBOL_CODE)" (click)="toggleFav(company.SYMBOL_CODE)"
                class="fas fa-star text-warning p-0 mx-7"></i>
              <i style="display:none;" *ngIf="!isFav(company.SYMBOL_CODE)" (click)="toggleFav(company.SYMBOL_CODE)"
                class="fas fa-star mx-7"></i>
              <button class="border-radios bg-success mx-7 font" (click)="orderBuy(company.SYMBOL_CODE, 0)">B</button>
              <button class="border-radios bg-danger mx-7 font" (click)="orderBuy(company.SYMBOL_CODE, 1)">S</button>
            </span> </small>
        </div>
      </div>
      <div class="d-flex flex-column align-self-center align-items-center" *ngIf="company">
        <div style="font-size: 24px;">
          <span class="row">
            <app-animated-text class="mx-2"
              [number]="company.LAST_TRADE_PRICE | number: numberFormat:'en-US'"></app-animated-text>
            <i class="ion-md-trending-up" style="color: limegreen;" *ngIf="company.LAST_CHANGE_PRC>0"></i>
            <i class="ion-md-trending-down" style="color: rgb(194, 74, 74);" *ngIf="company.LAST_CHANGE_PRC<0"></i>
          </span>
        </div>
        <div style="font-size: 16px; align-self: center !important"
          [ngClass]="company.LAST_CHANGE_PRC>0? 'green' : 'red'">
          <app-animated-text
            [number]="
              (company.LAST_CHANGE | number : numberFormat) +' ('+ (company.LAST_CHANGE_PRC | number : numberFormat) +'%)'"></app-animated-text>

          <!-- {{company.LAST_CHANGE | number : '1.2-2'}} ({{company.LAST_CHANGE_PRC | number : '1.2-2'}}%) -->
        </div>
        <!-- {{company.LAST_TRADE_DATE | date:'h:mm:ss a'}} -->
      </div>
    </div>
    
    <div class="w-100 row align-items-xl-center align-items-lg-center align-items-start">

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 " *ngIf="company">
        <div class="row justify-content-center">
          <div class="d-flex flex-column item-border profile-card-item" >
            <div class="profile-card-title">{{"bids"|translate}}</div>
            <!--
            <div> {{company.TOTAL_BIDS | number : '1.2-2'}}
            </div> -->
            <app-animated-text [number]="company.TOTAL_BIDS | number : '1.0-0'"></app-animated-text>

          </div>
          <div class="d-flex flex-column profile-card-item" >
            <div class="profile-card-title">{{"asks"|translate}}</div>
            <!-- <div> {{company.TOTAL_ASKS | number : '1.2-2'}}
            </div> -->
            <app-animated-text [number]="company.TOTAL_ASKS | number : '1.0-0'"></app-animated-text>

          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 " *ngIf="company">
        <div class="row justify-content-center">
          <div class="d-flex flex-column item-border profile-card-item" >
            <div class="profile-card-title">{{"high"|translate}}</div>
            <app-animated-text [number]="company.HIGH_PRICE | number : numberFormat"></app-animated-text>
          </div>
          <div class="d-flex flex-column profile-card-item" >
            <div class="profile-card-title">{{"low"|translate}}</div>
            <app-animated-text [number]="company.LOW_PRICE | number : numberFormat"></app-animated-text>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 " *ngIf="company">
        <div class="row justify-content-center">
          <div class="d-flex flex-column item-border profile-card-item" >
            <div class="profile-card-title">{{"close" | translate}}</div>
            <!-- <div>{{(company.CLOSE_PRICE)?(company.CLOSE_PRICE | number : '1.2-2'):(company.PREVIOUS_CLOSE | number :
              '1.2-2')}}
            </div> -->
            <app-animated-text [number]="(company.CLOSE_PRICE)?(company.CLOSE_PRICE | number : numberFormat):(company.PREVIOUS_CLOSE | number :
            numberFormat)">
            </app-animated-text>
          </div>
          <div class="d-flex flex-column profile-card-item" >
            <div class="profile-card-title">{{"open"|translate}}</div>
            <app-animated-text [number]="company.OPEN_PRICE | number : numberFormat"></app-animated-text>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 " *ngIf="company">
        <div class="row justify-content-center">
          <div class="d-flex flex-column item-border profile-card-item" >
            <div class="profile-card-title">{{"volume"|translate}}</div>
            <app-animated-text [number]="company.TOTAL_VOLUME | number : '1.0-0'"></app-animated-text>
          </div>
          <div class="d-flex flex-column profile-card-item" >
            <div class="profile-card-title">{{"turnover"|translate}}</div>
            <app-animated-text [number]="company.TOTAL_VALUE | number : numberFormat"></app-animated-text>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12 ">
        <div class="row justify-content-center">

        </div>
      </div>
    </div>

  </div>
  <div class="row m-3" id="dark">
    <div class="tradingview-widget-container p-1 col-md-6">
      <div id="tradingview_bac65"></div>
      <script type="text/javascript" src="https://s3.tradingview.com/tv.js"></script>
      <script type="text/javascript">
      </script>
    </div>

    <div class="p-1 col-md-6 trades-news" *ngIf="company">
      <div class="row p-1">
        <div class="col-md-6 p-0" style="height: 261px;">
          <app-trades class="trades-news" [reuters]="reuters" [symbolCode]="symbolCode"></app-trades>
        </div>
        <div class="col-md-6 p-0" style="height: 261px;">
          <div class="market-news">
            <h2 class="heading">{{"symbol-info"|translate}}</h2>

            <div class="d-flex justify-content-between symbol-info-item">
              <div class=" p-2"> {{"last-update"|translate}}: </div>
              <div class="p-2">{{company.LAST_TRADE_DATE | date:'d/M/yy, h:mm a'}}</div>
            </div>
            <div class="d-flex justify-content-between symbol-info-item">
              <div class=" p-2">{{"market"|translate}}: </div>
              <div class="p-2">{{company.MARKET_ID}}</div>
            </div>
            <div class="d-flex justify-content-between symbol-info-item">
              <div class=" p-2">{{"sector"|translate}}: </div>
              <div class="p-2" style="text-overflow: ellipsis; white-space: nowrap;overflow: hidden;">
                {{sector}}</div>
            </div>
            <div class="d-flex justify-content-between symbol-info-item">
              <div class=" p-2">{{"status"|translate}}: </div>
              <div class="p-2 green" *ngIf="company.SYMBOL_STATE == 'A'">Active</div>
              <div class="p-2 red" *ngIf="company.SYMBOL_STATE != 'A'">Suspended</div>
            </div>
            <div class="d-flex justify-content-between symbol-info-item">
              <div class=" p-2">{{"currency"|translate}}: </div>
              <div class="p-2" *ngIf="company.CURRENCY == 1">EGP</div>
              <div class="p-2" *ngIf="company.CURRENCY == 2">USD</div>
            </div>
            <div class="d-flex justify-content-between symbol-info-item">
              <div class=" p-2">{{'num-shares'|translate}}: </div>
              <div class="p-2">{{company.LISTED_SHARES | customNumber}}</div>
            </div>


          </div>
        </div>
      </div>

      <div class="row p-1">
        <!-- <div class="col-md-6" style="padding: 5px !important; height: 280px;">
          <app-market-depth-asks [symbolCode]="this.symbolCode"></app-market-depth-asks>
        </div>
        <div class="col-md-6" style="padding: 5px !important; height: 280px;">
          <app-market-depth-bids [symbolCode]="this.symbolCode"></app-market-depth-bids>
        </div> -->
        <div class="col-md-12 mt-1 p-0" style="height: 280px;">
          <app-market-depth [symbolCode]="this.symbolCode"></app-market-depth>
        </div>
      </div>

    </div>
    <div class="col-md-4" style="max-height: 535px;">
      <app-news class="trades-news" [symbolCode]="this.symbolCode"></app-news>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4  col-12 trades-news">
      <div class="no-market-overlay" *ngIf="!isMarket">
        <app-not-full-market></app-not-full-market>
      </div>
      <div class="tradingview-widget-container technical-card" [ngClass]="(!isMarket)?'blur':''">
        <div class="tradingview-widget-container__widget"></div>
        <div #tradingFinancial></div>
        <div class="tradingview-widget-copyright"><a
            href="https://www.tradingview.com/symbols/{{symbolCode}}/financials-overview/" rel="noopener"
            target="_blank"><span class="blue-text">AAPL Fundamental Data for {{reuters}}</span></a> by TradingView
        </div>
      </div>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4  col-12 trades-news">
      <div class="no-market-overlay" *ngIf="!isMarket">
        <app-not-full-market></app-not-full-market>
      </div>
      <div class="tradingview-widget-container technical-card" [ngClass]="(!isMarket)?'blur':''">
        <div class="tradingview-widget-container__widget"></div>
        <div #tradingTechnical></div>
        <div class="tradingview-widget-copyright"><a
            href="https://www.tradingview.com/symbols/{{symbolCode}}/technicals/" rel="noopener" target="_blank"><span
              class="blue-text">Technical Analysis for {{reuters}}</span></a> by TradingView</div>
      </div>
    </div>

  </div>
</div>